import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-worker-escalation-list',
  templateUrl: './worker-escalation-list.component.html',
  styleUrls: ['./worker-escalation-list.component.scss']
})
export class WorkerEscalationListComponent implements OnInit {

  workers: any;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {
    this.getWorkers();
  }

  getWorkers(){

    this.okService.get('reports/workerescalationlist',{})
    .subscribe((data) => {

      this.workers = data.body;

    });
  }

  export(){

    this.okService.download("reports/workerescalationlist",{export:true});

  }
}
